import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F91AD38D-33E3-46A4-83BC-17B671750D6C
 * name folder-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-multiple-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderMultipleOutlineIcon = createSvgIcon(<><path d="M22,4A2,2 0 0,1 24,6V16A2,2 0 0,1 22,18H6A2,2 0 0,1 4,16V4A2,2 0 0,1 6,2H12L14,4H22M2,6V20H20V22H2A2,2 0 0,1 0,20V11H0V6H2M6,6V16H22V6H6Z" /></>, 'FolderMultipleOutlineIcon');
export default FolderMultipleOutlineIcon